const canvasQueues = new WeakMap<object, Promise<void>>();

export const enqueueCanvasOperation = <Result>(
  canvas: object,
  operation: () => Result | Promise<Result>,
): Promise<Result> => {
  const previousOperation = canvasQueues.get(canvas) ?? Promise.resolve();
  const currentOperation = previousOperation.catch(() => undefined).then(operation);

  canvasQueues.set(
    canvas,
    currentOperation.then(
      () => undefined,
      () => undefined,
    ),
  );

  return currentOperation;
};
